export default "__VITE_ASSET__Cb$wribm__"